import { redirect } from 'react-router';
import { getDisplayMode } from '@/hooks/use-user-platform';
import ROUTES from '@/routes';

export function contactScanLoader() {
  if (getDisplayMode() === 'desktop') {
    return redirect(ROUTES.CONTACT.$path());
  }

  return {};
}
